module.exports = __webpack_public_path__ + "static/media/main_menu.1be8df23.svg";